import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';

import { ShellService, EModalSize, EToasterType, EToasterPosition } from './shell.service'
export { EModalSize, EToasterType, EToasterPosition } from './shell.service';
import { ToastrService } from 'ngx-toastr';
import { FootPrintPortalManager_dock_appointment_cancel_options_formComponent } from './FootPrintPortalManager.dock_appointment_cancel_options_form.component';
import { FootPrintPortalManager_dock_appointment_creation_formComponent } from './FootPrintPortalManager.dock_appointment_creation_form.component';
import { FootPrintPortalManager_lot_bulk_update_status_formComponent } from './FootPrintPortalManager.lot_bulk_update_status_form.component';
import { FootPrintPortalManager_lot_creation_formComponent } from './FootPrintPortalManager.lot_creation_form.component';
import { FootPrintPortalManager_material_creation_formComponent } from './FootPrintPortalManager.material_creation_form.component';
import { FootPrintPortalManager_receiving_order_creation_formComponent } from './FootPrintPortalManager.receiving_order_creation_form.component';
import { FootPrintPortalManager_receiving_orders_update_formComponent } from './FootPrintPortalManager.receiving_orders_update_form.component';
import { FootPrintPortalManager_shipping_order_cancellation_options_formComponent } from './FootPrintPortalManager.shipping_order_cancellation_options_form.component';
import { FootPrintPortalManager_shipping_order_creation_formComponent } from './FootPrintPortalManager.shipping_order_creation_form.component';
import { FootPrintPortalManager_shipping_orders_update_formComponent } from './FootPrintPortalManager.shipping_orders_update_form.component';
import { FootPrintPortalManager_vendorlot_creation_formComponent } from './FootPrintPortalManager.vendorlot_creation_form.component';
import { FootPrintPortalManager_asn_order_editorComponent } from './FootPrintPortalManager.asn_order_editor.component';
import { FootPrintPortalManager_dock_appointment_editorComponent } from './FootPrintPortalManager.dock_appointment_editor.component';
import { FootPrintPortalManager_invoice_editorComponent } from './FootPrintPortalManager.invoice_editor.component';
import { FootPrintPortalManager_lot_editorComponent } from './FootPrintPortalManager.lot_editor.component';
import { FootPrintPortalManager_material_editorComponent } from './FootPrintPortalManager.material_editor.component';
import { FootPrintPortalManager_pallet_editorComponent } from './FootPrintPortalManager.pallet_editor.component';
import { FootPrintPortalManager_receiving_order_editorComponent } from './FootPrintPortalManager.receiving_order_editor.component';
import { FootPrintPortalManager_serialnumber_editorComponent } from './FootPrintPortalManager.serialnumber_editor.component';
import { FootPrintPortalManager_shipping_order_editorComponent } from './FootPrintPortalManager.shipping_order_editor.component';
import { FootPrintPortalManager_accounts_gridComponent } from './FootPrintPortalManager.accounts_grid.component';
import { FootPrintPortalManager_asn_order_licenseplates_gridComponent } from './FootPrintPortalManager.asn_order_licenseplates_grid.component';
import { FootPrintPortalManager_asn_order_licenseplates_receiving_tasks_gridComponent } from './FootPrintPortalManager.asn_order_licenseplates_receiving_tasks_grid.component';
import { FootPrintPortalManager_asn_order_receiving_tasks_gridComponent } from './FootPrintPortalManager.asn_order_receiving_tasks_grid.component';
import { FootPrintPortalManager_asn_order_tasks_gridComponent } from './FootPrintPortalManager.asn_order_tasks_grid.component';
import { FootPrintPortalManager_billing_records_by_invoiceline_gridComponent } from './FootPrintPortalManager.billing_records_by_invoiceline_grid.component';
import { FootPrintPortalManager_entity_attachments_gridComponent } from './FootPrintPortalManager.entity_attachments_grid.component';
import { FootPrintPortalManager_instructions_gridComponent } from './FootPrintPortalManager.instructions_grid.component';
import { FootPrintPortalManager_inventory_lot_gridComponent } from './FootPrintPortalManager.inventory_lot_grid.component';
import { FootPrintPortalManager_inventory_lot_snapshot_gridComponent } from './FootPrintPortalManager.inventory_lot_snapshot_grid.component';
import { FootPrintPortalManager_inventory_material_gridComponent } from './FootPrintPortalManager.inventory_material_grid.component';
import { FootPrintPortalManager_inventory_material_snapshot_gridComponent } from './FootPrintPortalManager.inventory_material_snapshot_grid.component';
import { FootPrintPortalManager_inventory_pallet_gridComponent } from './FootPrintPortalManager.inventory_pallet_grid.component';
import { FootPrintPortalManager_inventory_pallet_snapshot_gridComponent } from './FootPrintPortalManager.inventory_pallet_snapshot_grid.component';
import { FootPrintPortalManager_inventory_tasks_gridComponent } from './FootPrintPortalManager.inventory_tasks_grid.component';
import { FootPrintPortalManager_inventory_transactions_gridComponent } from './FootPrintPortalManager.inventory_transactions_grid.component';
import { FootPrintPortalManager_invoice_lines_gridComponent } from './FootPrintPortalManager.invoice_lines_grid.component';
import { FootPrintPortalManager_invoices_gridComponent } from './FootPrintPortalManager.invoices_grid.component';
import { FootPrintPortalManager_lots_grid_flatComponent } from './FootPrintPortalManager.lots_grid_flat.component';
import { FootPrintPortalManager_material_packagings_gridComponent } from './FootPrintPortalManager.material_packagings_grid.component';
import { FootPrintPortalManager_materials_by_base_packaging_gridComponent } from './FootPrintPortalManager.materials_by_base_packaging_grid.component';
import { FootPrintPortalManager_orderaddresses_gridComponent } from './FootPrintPortalManager.orderaddresses_grid.component';
import { FootPrintPortalManager_orders_dashboard_gridComponent } from './FootPrintPortalManager.orders_dashboard_grid.component';
import { FootPrintPortalManager_ownersaccounts_gridComponent } from './FootPrintPortalManager.ownersaccounts_grid.component';
import { FootPrintPortalManager_receiving_order_lines_gridComponent } from './FootPrintPortalManager.receiving_order_lines_grid.component';
import { FootPrintPortalManager_receiving_order_received_inventory_gridComponent } from './FootPrintPortalManager.receiving_order_received_inventory_grid.component';
import { FootPrintPortalManager_receiving_order_tasks_gridComponent } from './FootPrintPortalManager.receiving_order_tasks_grid.component';
import { FootPrintPortalManager_receiving_orders_gridComponent } from './FootPrintPortalManager.receiving_orders_grid.component';
import { FootPrintPortalManager_serialnumbers_gridComponent } from './FootPrintPortalManager.serialnumbers_grid.component';
import { FootPrintPortalManager_shipping_order_lines_gridComponent } from './FootPrintPortalManager.shipping_order_lines_grid.component';
import { FootPrintPortalManager_shipping_order_tasks_gridComponent } from './FootPrintPortalManager.shipping_order_tasks_grid.component';
import { FootPrintPortalManager_shipping_orders_by_tracking_gridComponent } from './FootPrintPortalManager.shipping_orders_by_tracking_grid.component';
import { FootPrintPortalManager_shipping_orders_gridComponent } from './FootPrintPortalManager.shipping_orders_grid.component';
import { FootPrintPortalManager_shippingcontents_gridComponent } from './FootPrintPortalManager.shippingcontents_grid.component';
import { FootPrintPortalManager_inventory_hubComponent } from './FootPrintPortalManager.inventory_hub.component';
import { FootPrintPortalManager_inventory_transactions_hubComponent } from './FootPrintPortalManager.inventory_transactions_hub.component';
import { FootPrintPortalManager_invoices_hubComponent } from './FootPrintPortalManager.invoices_hub.component';
import { FootPrintPortalManager_lots_hubComponent } from './FootPrintPortalManager.lots_hub.component';
import { FootPrintPortalManager_material_attachments_hubComponent } from './FootPrintPortalManager.material_attachments_hub.component';
import { FootPrintPortalManager_materials_hubComponent } from './FootPrintPortalManager.materials_hub.component';
import { FootPrintPortalManager_orders_dashboard_hubComponent } from './FootPrintPortalManager.orders_dashboard_hub.component';
import { FootPrintPortalManager_orders_hubComponent } from './FootPrintPortalManager.orders_hub.component';
import { FootPrintPortalManager_receiving_orders_hubComponent } from './FootPrintPortalManager.receiving_orders_hub.component';
import { FootPrintPortalManager_serialnumbers_hubComponent } from './FootPrintPortalManager.serialnumbers_hub.component';
import { FootPrintPortalManager_shipping_orders_hubComponent } from './FootPrintPortalManager.shipping_orders_hub.component';
import { FootPrintPortalManager_single_lot_hubComponent } from './FootPrintPortalManager.single_lot_hub.component';
import { FootPrintPortalManager_single_material_hubComponent } from './FootPrintPortalManager.single_material_hub.component';
import { FootPrintPortalManager_single_pallet_hubComponent } from './FootPrintPortalManager.single_pallet_hub.component';
import { FootPrintPortalManager_single_project_hubComponent } from './FootPrintPortalManager.single_project_hub.component';
import { FootPrintPortalManager_single_serialnumber_hubComponent } from './FootPrintPortalManager.single_serialnumber_hub.component';
import { FootPrintPortalManager_archived_options_dd_singleComponent } from './FootPrintPortalManager.archived_options_dd_single.component';
import { FootPrintPortalManager_inbound_outbound_appointment_types_dd_singleComponent } from './FootPrintPortalManager.inbound_outbound_appointment_types_dd_single.component';
import { FootPrintPortalManager_inventory_aggregation_dd_singleComponent } from './FootPrintPortalManager.inventory_aggregation_dd_single.component';
import { FootPrintPortalManager_lots_dd_singleComponent } from './FootPrintPortalManager.lots_dd_single.component';
import { FootPrintPortalManager_operationcodes_dd_singleComponent } from './FootPrintPortalManager.operationcodes_dd_single.component';
import { FootPrintPortalManager_vendorlots_dd_singleComponent } from './FootPrintPortalManager.vendorlots_dd_single.component';
import { FootPrintPortalManager_archived_options_dd_multiComponent } from './FootPrintPortalManager.archived_options_dd_multi.component';
import { FootPrintPortalManager_inbound_outbound_appointment_types_dd_multiComponent } from './FootPrintPortalManager.inbound_outbound_appointment_types_dd_multi.component';
import { FootPrintPortalManager_inventory_aggregation_dd_multiComponent } from './FootPrintPortalManager.inventory_aggregation_dd_multi.component';
import { FootPrintPortalManager_lots_dd_multiComponent } from './FootPrintPortalManager.lots_dd_multi.component';
import { FootPrintPortalManager_operationcodes_dd_multiComponent } from './FootPrintPortalManager.operationcodes_dd_multi.component';
import { FootPrintPortalManager_vendorlots_dd_multiComponent } from './FootPrintPortalManager.vendorlots_dd_multi.component';

import { Discussions_ShellService } from './Discussions.shell.service';
import { Utilities_ShellService } from './Utilities.shell.service';
import { Addresses_ShellService } from './Addresses.shell.service';
import { AsnOrders_ShellService } from './AsnOrders.shell.service';
import { Attachments_ShellService } from './Attachments.shell.service';
import { Carriers_ShellService } from './Carriers.shell.service';
import { Instructions_ShellService } from './Instructions.shell.service';
import { ExcelOrderImport_ShellService } from './ExcelOrderImport.shell.service';
import { Locations_ShellService } from './Locations.shell.service';
import { Lots_ShellService } from './Lots.shell.service';
import { LoadContainers_ShellService } from './LoadContainers.shell.service';
import { Owners_ShellService } from './Owners.shell.service';
import { PurchaseOrders_ShellService } from './PurchaseOrders.shell.service';
import { Invoices_ShellService } from './Invoices.shell.service';
import { Notifications_ShellService } from './Notifications.shell.service';
import { Materials_ShellService } from './Materials.shell.service';
import { DockAppointments_ShellService } from './DockAppointments.shell.service';
import { SerialNumbers_ShellService } from './SerialNumbers.shell.service';
import { SalesOrders_ShellService } from './SalesOrders.shell.service';
import { Inventory_ShellService } from './Inventory.shell.service';

@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_ShellService extends ShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    public Discussions: Discussions_ShellService,
    public Utilities: Utilities_ShellService,
    public Addresses: Addresses_ShellService,
    public AsnOrders: AsnOrders_ShellService,
    public Attachments: Attachments_ShellService,
    public Carriers: Carriers_ShellService,
    public Instructions: Instructions_ShellService,
    public ExcelOrderImport: ExcelOrderImport_ShellService,
    public Locations: Locations_ShellService,
    public Lots: Lots_ShellService,
    public LoadContainers: LoadContainers_ShellService,
    public Owners: Owners_ShellService,
    public PurchaseOrders: PurchaseOrders_ShellService,
    public Invoices: Invoices_ShellService,
    public Notifications: Notifications_ShellService,
    public Materials: Materials_ShellService,
    public DockAppointments: DockAppointments_ShellService,
    public SerialNumbers: SerialNumbers_ShellService,
    public SalesOrders: SalesOrders_ShellService,
    public Inventory: Inventory_ShellService,
  ) {
    super(dialog, toastr);
  }

  public FootPrintPortalManager: FootPrintPortalManager_ShellService = this;

  // wizards shouldn't be opened in blades (hacky check with "#unless steps" to recognize the config type)
  public opendock_appointment_cancel_options_form(inParams:{ title?: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Dock Appointment Cancellation',
        referenceName: 'FootPrintPortalManager_dock_appointment_cancel_options_form',
        component: FootPrintPortalManager_dock_appointment_cancel_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_cancel_options_formDialog(
    inParams:{ title?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, reasonCodeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_dock_appointment_cancel_options_formComponent,
      'Dock Appointment Cancellation',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_creation_form(inParams:{ warehouseId?: number[], lookupcode?: string, scheduledArrival?: string, scheduledDeparture?: string, dockDoor?: number, typeId?: number, ownerId?: number, projectId?: number, carrierId?: number, orderId?: number, loadContainerId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Create Dock Appointment',
        referenceName: 'FootPrintPortalManager_dock_appointment_creation_form',
        component: FootPrintPortalManager_dock_appointment_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_creation_formDialog(
    inParams:{ warehouseId?: number[], lookupcode?: string, scheduledArrival?: string, scheduledDeparture?: string, dockDoor?: number, typeId?: number, ownerId?: number, projectId?: number, carrierId?: number, orderId?: number, loadContainerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_dock_appointment_creation_formComponent,
      'Create Dock Appointment',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlot_bulk_update_status_form(inParams:{ message: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Lot status update',
        referenceName: 'FootPrintPortalManager_lot_bulk_update_status_form',
        component: FootPrintPortalManager_lot_bulk_update_status_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlot_bulk_update_status_formDialog(
    inParams:{ message: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ statusId?: number, reasonCodeIds?: number[] }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_lot_bulk_update_status_formComponent,
      'Lot status update',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlot_creation_form(inParams:{ materialId: number, lotLookupCode?: string, vendorLotLookupCode?: string, vendorLotId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Create Lot',
        referenceName: 'FootPrintPortalManager_lot_creation_form',
        component: FootPrintPortalManager_lot_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlot_creation_formDialog(
    inParams:{ materialId: number, lotLookupCode?: string, vendorLotLookupCode?: string, vendorLotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ lotId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_lot_creation_formComponent,
      'Create Lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_creation_form(inParams:{ projectId?: number, ownerId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Create Material',
        referenceName: 'FootPrintPortalManager_material_creation_form',
        component: FootPrintPortalManager_material_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ materialId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_material_creation_formComponent,
      'Create Material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreceiving_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Create Receiving Order',
        referenceName: 'FootPrintPortalManager_receiving_order_creation_form',
        component: FootPrintPortalManager_receiving_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreceiving_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_order_creation_formComponent,
      'Create Receiving Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreceiving_orders_update_form(replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Update Receiving Orders',
        referenceName: 'FootPrintPortalManager_receiving_orders_update_form',
        component: FootPrintPortalManager_receiving_orders_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openreceiving_orders_update_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, carrierId?: number, expectedDate?: string, reference?: string }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_orders_update_formComponent,
      'Update Receiving Orders',
      mode,
      dialogSize
    )
  }
  public openshipping_order_cancellation_options_form(inParams:{ title?: string, parentId: number, parentEntity: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Generic Shipping Order Cancellation ',
        referenceName: 'FootPrintPortalManager_shipping_order_cancellation_options_form',
        component: FootPrintPortalManager_shipping_order_cancellation_options_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_order_cancellation_options_formDialog(
    inParams:{ title?: string, parentId: number, parentEntity: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean, reasonCodeId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_order_cancellation_options_formComponent,
      'Generic Shipping Order Cancellation ',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_order_creation_form(inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Create Shipping Order',
        referenceName: 'FootPrintPortalManager_shipping_order_creation_form',
        component: FootPrintPortalManager_shipping_order_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_order_creation_formDialog(
    inParams:{ projectId?: number, ownerId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_order_creation_formComponent,
      'Create Shipping Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_orders_update_form(inParams:{ orders: { orderId?: number, shipmentId?: number }[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Update Shipping Orders',
        referenceName: 'FootPrintPortalManager_shipping_orders_update_form',
        component: FootPrintPortalManager_shipping_orders_update_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_orders_update_formDialog(
    inParams:{ orders: { orderId?: number, shipmentId?: number }[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_orders_update_formComponent,
      'Update Shipping Orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openvendorlot_creation_form(inParams:{ materialId: number, vendorLookupcode?: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Create Vendor Lot',
        referenceName: 'FootPrintPortalManager_vendorlot_creation_form',
        component: FootPrintPortalManager_vendorlot_creation_formComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openvendorlot_creation_formDialog(
    inParams:{ materialId: number, vendorLookupcode?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ vendorLotId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_vendorlot_creation_formComponent,
      'Create Vendor Lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_editor(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Edit ASN Order',
        referenceName: 'FootPrintPortalManager_asn_order_editor',
        component: FootPrintPortalManager_asn_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_editorDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_asn_order_editorComponent,
      'Edit ASN Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opendock_appointment_editor(inParams:{ dockAppointmentId: number, orderId?: number, loadContainerId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Dock Appointment Editor',
        referenceName: 'FootPrintPortalManager_dock_appointment_editor',
        component: FootPrintPortalManager_dock_appointment_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opendock_appointment_editorDialog(
    inParams:{ dockAppointmentId: number, orderId?: number, loadContainerId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_dock_appointment_editorComponent,
      'Dock Appointment Editor',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoice_editor(inParams:{ invoiceId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'View Invoice',
        referenceName: 'FootPrintPortalManager_invoice_editor',
        component: FootPrintPortalManager_invoice_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoice_editorDialog(
    inParams:{ invoiceId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_invoice_editorComponent,
      'View Invoice',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlot_editor(inParams:{ lotId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Edit Lot',
        referenceName: 'FootPrintPortalManager_lot_editor',
        component: FootPrintPortalManager_lot_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlot_editorDialog(
    inParams:{ lotId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_lot_editorComponent,
      'Edit Lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_editor(inParams:{ materialId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Edit Material',
        referenceName: 'FootPrintPortalManager_material_editor',
        component: FootPrintPortalManager_material_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_editorDialog(
    inParams:{ materialId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_material_editorComponent,
      'Edit Material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openpallet_editor(inParams:{ licenseplateId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Edit Pallet',
        referenceName: 'FootPrintPortalManager_pallet_editor',
        component: FootPrintPortalManager_pallet_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openpallet_editorDialog(
    inParams:{ licenseplateId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_pallet_editorComponent,
      'Edit Pallet',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreceiving_order_editor(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Edit Receiving Order',
        referenceName: 'FootPrintPortalManager_receiving_order_editor',
        component: FootPrintPortalManager_receiving_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreceiving_order_editorDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_order_editorComponent,
      'Edit Receiving Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openserialnumber_editor(inParams:{ serialnumberId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Edit Serialnumber',
        referenceName: 'FootPrintPortalManager_serialnumber_editor',
        component: FootPrintPortalManager_serialnumber_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumber_editorDialog(
    inParams:{ serialnumberId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_serialnumber_editorComponent,
      'Edit Serialnumber',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_order_editor(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Edit Shipping Order',
        referenceName: 'FootPrintPortalManager_shipping_order_editor',
        component: FootPrintPortalManager_shipping_order_editorComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_order_editorDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_order_editorComponent,
      'Edit Shipping Order',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openaccounts_grid(inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Addresses',
        referenceName: 'FootPrintPortalManager_accounts_grid',
        component: FootPrintPortalManager_accounts_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openaccounts_gridDialog(
    inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ accountId?: number, contactId?: number, addressId?: number, confirm?: boolean, ownerId?: number }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_accounts_gridComponent,
      'Addresses',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_licenseplates_grid(inParams:{ orderId: number, orderStatusId: number, projectId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Pallets',
        referenceName: 'FootPrintPortalManager_asn_order_licenseplates_grid',
        component: FootPrintPortalManager_asn_order_licenseplates_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_licenseplates_gridDialog(
    inParams:{ orderId: number, orderStatusId: number, projectId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_asn_order_licenseplates_gridComponent,
      'Pallets',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_licenseplates_receiving_tasks_grid(inParams:{ licenseplateId: number, orderId: number, projectId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootPrintPortalManager_asn_order_licenseplates_receiving_tasks_grid',
        component: FootPrintPortalManager_asn_order_licenseplates_receiving_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_licenseplates_receiving_tasks_gridDialog(
    inParams:{ licenseplateId: number, orderId: number, projectId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_asn_order_licenseplates_receiving_tasks_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_receiving_tasks_grid(inParams:{ orderId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Receiving tasks',
        referenceName: 'FootPrintPortalManager_asn_order_receiving_tasks_grid',
        component: FootPrintPortalManager_asn_order_receiving_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_receiving_tasks_gridDialog(
    inParams:{ orderId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_asn_order_receiving_tasks_gridComponent,
      'Receiving tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openasn_order_tasks_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Asn order tasks',
        referenceName: 'FootPrintPortalManager_asn_order_tasks_grid',
        component: FootPrintPortalManager_asn_order_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openasn_order_tasks_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_asn_order_tasks_gridComponent,
      'Asn order tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openbilling_records_by_invoiceline_grid(inParams:{ invoiceLineId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Billing records by invoice line',
        referenceName: 'FootPrintPortalManager_billing_records_by_invoiceline_grid',
        component: FootPrintPortalManager_billing_records_by_invoiceline_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openbilling_records_by_invoiceline_gridDialog(
    inParams:{ invoiceLineId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_billing_records_by_invoiceline_gridComponent,
      'Billing records by invoice line',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openentity_attachments_grid(inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Attachments',
        referenceName: 'FootPrintPortalManager_entity_attachments_grid',
        component: FootPrintPortalManager_entity_attachments_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openentity_attachments_gridDialog(
    inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_entity_attachments_gridComponent,
      'Attachments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinstructions_grid(inParams:{ entityName: string, enabled: boolean, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Instructions',
        referenceName: 'FootPrintPortalManager_instructions_grid',
        component: FootPrintPortalManager_instructions_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinstructions_gridDialog(
    inParams:{ entityName: string, enabled: boolean, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_instructions_gridComponent,
      'Instructions',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_lot_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], lotId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory by lot',
        referenceName: 'FootPrintPortalManager_inventory_lot_grid',
        component: FootPrintPortalManager_inventory_lot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_lot_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], lotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_lot_gridComponent,
      'Inventory by lot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_lot_snapshot_grid(inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory lot snapshot',
        referenceName: 'FootPrintPortalManager_inventory_lot_snapshot_grid',
        component: FootPrintPortalManager_inventory_lot_snapshot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_lot_snapshot_gridDialog(
    inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_lot_snapshot_gridComponent,
      'Inventory lot snapshot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_material_grid(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory by material',
        referenceName: 'FootPrintPortalManager_inventory_material_grid',
        component: FootPrintPortalManager_inventory_material_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_material_gridDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_material_gridComponent,
      'Inventory by material',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_material_snapshot_grid(inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory material snapshot',
        referenceName: 'FootPrintPortalManager_inventory_material_snapshot_grid',
        component: FootPrintPortalManager_inventory_material_snapshot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_material_snapshot_gridDialog(
    inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_material_snapshot_gridComponent,
      'Inventory material snapshot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_pallet_grid(inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory by pallet',
        referenceName: 'FootPrintPortalManager_inventory_pallet_grid',
        component: FootPrintPortalManager_inventory_pallet_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_pallet_gridDialog(
    inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_pallet_gridComponent,
      'Inventory by pallet',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_pallet_snapshot_grid(inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory pallet snapshot',
        referenceName: 'FootPrintPortalManager_inventory_pallet_snapshot_grid',
        component: FootPrintPortalManager_inventory_pallet_snapshot_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_pallet_snapshot_gridDialog(
    inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_pallet_snapshot_gridComponent,
      'Inventory pallet snapshot',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_tasks_grid(inParams:{ materialIds?: number[], projectId?: number, ownerId?: number, warehouseIds?: number[], serialnumberId?: number, licenseplateId?: number, lotId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory tasks',
        referenceName: 'FootPrintPortalManager_inventory_tasks_grid',
        component: FootPrintPortalManager_inventory_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_tasks_gridDialog(
    inParams:{ materialIds?: number[], projectId?: number, ownerId?: number, warehouseIds?: number[], serialnumberId?: number, licenseplateId?: number, lotId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_tasks_gridComponent,
      'Inventory tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transactions_grid(inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], createdFrom?: string, createdTo?: string, materialIds?: number[], operationCodeIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Transactions',
        referenceName: 'FootPrintPortalManager_inventory_transactions_grid',
        component: FootPrintPortalManager_inventory_transactions_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_transactions_gridDialog(
    inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], createdFrom?: string, createdTo?: string, materialIds?: number[], operationCodeIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_transactions_gridComponent,
      'Transactions',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoice_lines_grid(inParams:{ invoiceId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Invoice lines',
        referenceName: 'FootPrintPortalManager_invoice_lines_grid',
        component: FootPrintPortalManager_invoice_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoice_lines_gridDialog(
    inParams:{ invoiceId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_invoice_lines_gridComponent,
      'Invoice lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinvoices_grid(inParams:{ ownerId: number, projectId?: number, statusIds: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Invoices',
        referenceName: 'FootPrintPortalManager_invoices_grid',
        component: FootPrintPortalManager_invoices_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoices_gridDialog(
    inParams:{ ownerId: number, projectId?: number, statusIds: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_invoices_gridComponent,
      'Invoices',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlots_grid_flat(inParams:{ ownerId: number, projectId?: number, materialIds?: number[], statusIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Lots grid from flat data source',
        referenceName: 'FootPrintPortalManager_lots_grid_flat',
        component: FootPrintPortalManager_lots_grid_flatComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlots_grid_flatDialog(
    inParams:{ ownerId: number, projectId?: number, materialIds?: number[], statusIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_lots_grid_flatComponent,
      'Lots grid from flat data source',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_packagings_grid(inParams:{ materialId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Packagings',
        referenceName: 'FootPrintPortalManager_material_packagings_grid',
        component: FootPrintPortalManager_material_packagings_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_packagings_gridDialog(
    inParams:{ materialId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_material_packagings_gridComponent,
      'Packagings',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterials_by_base_packaging_grid(inParams:{ projectId?: number, ownerId: number, materialIds?: number[] }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Materials',
        referenceName: 'FootPrintPortalManager_materials_by_base_packaging_grid',
        component: FootPrintPortalManager_materials_by_base_packaging_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterials_by_base_packaging_gridDialog(
    inParams:{ projectId?: number, ownerId: number, materialIds?: number[] }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_materials_by_base_packaging_gridComponent,
      'Materials',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openorderaddresses_grid(inParams:{ orderId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Order addresses',
        referenceName: 'FootPrintPortalManager_orderaddresses_grid',
        component: FootPrintPortalManager_orderaddresses_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openorderaddresses_gridDialog(
    inParams:{ orderId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_orderaddresses_gridComponent,
      'Order addresses',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openorders_dashboard_grid(inParams:{ ownerId: number, projectId?: number, warehouseIds: number[], typeIds?: number[], statusIds?: number[], fromDate?: string, toDate?: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Order dashboard',
        referenceName: 'FootPrintPortalManager_orders_dashboard_grid',
        component: FootPrintPortalManager_orders_dashboard_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openorders_dashboard_gridDialog(
    inParams:{ ownerId: number, projectId?: number, warehouseIds: number[], typeIds?: number[], statusIds?: number[], fromDate?: string, toDate?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_orders_dashboard_gridComponent,
      'Order dashboard',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openownersaccounts_grid(inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Contacts',
        referenceName: 'FootPrintPortalManager_ownersaccounts_grid',
        component: FootPrintPortalManager_ownersaccounts_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openownersaccounts_gridDialog(
    inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ accountId?: number, contactId?: number, addressId?: number, confirm?: boolean }> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_ownersaccounts_gridComponent,
      'Contacts',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreceiving_order_lines_grid(inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Receiving order lines',
        referenceName: 'FootPrintPortalManager_receiving_order_lines_grid',
        component: FootPrintPortalManager_receiving_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreceiving_order_lines_gridDialog(
    inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_order_lines_gridComponent,
      'Receiving order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreceiving_order_received_inventory_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Received Inventory',
        referenceName: 'FootPrintPortalManager_receiving_order_received_inventory_grid',
        component: FootPrintPortalManager_receiving_order_received_inventory_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreceiving_order_received_inventory_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_order_received_inventory_gridComponent,
      'Received Inventory',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreceiving_order_tasks_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Receiving order tasks',
        referenceName: 'FootPrintPortalManager_receiving_order_tasks_grid',
        component: FootPrintPortalManager_receiving_order_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreceiving_order_tasks_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_order_tasks_gridComponent,
      'Receiving order tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openreceiving_orders_grid(inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], materialIds?: number[], reference?: string, fromDate?: string, toDate?: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Receiving orders',
        referenceName: 'FootPrintPortalManager_receiving_orders_grid',
        component: FootPrintPortalManager_receiving_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openreceiving_orders_gridDialog(
    inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], materialIds?: number[], reference?: string, fromDate?: string, toDate?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_orders_gridComponent,
      'Receiving orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openserialnumbers_grid(inParams:{ licenseplateIds?: number[], warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId: number, archived?: boolean, search?: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Serial numbers',
        referenceName: 'FootPrintPortalManager_serialnumbers_grid',
        component: FootPrintPortalManager_serialnumbers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumbers_gridDialog(
    inParams:{ licenseplateIds?: number[], warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId: number, archived?: boolean, search?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_serialnumbers_gridComponent,
      'Serial numbers',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_order_lines_grid(inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, orderState?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Shipping order lines',
        referenceName: 'FootPrintPortalManager_shipping_order_lines_grid',
        component: FootPrintPortalManager_shipping_order_lines_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_order_lines_gridDialog(
    inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, orderState?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_order_lines_gridComponent,
      'Shipping order lines',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_order_tasks_grid(inParams:{ orderId?: number, shipmentId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Shipping order tasks',
        referenceName: 'FootPrintPortalManager_shipping_order_tasks_grid',
        component: FootPrintPortalManager_shipping_order_tasks_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_order_tasks_gridDialog(
    inParams:{ orderId?: number, shipmentId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_order_tasks_gridComponent,
      'Shipping order tasks',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_orders_by_tracking_grid(inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], reference?: string, materialIds?: number[], fromDate?: string, toDate?: string, ship_to_search?: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Shipping orders by tracking number',
        referenceName: 'FootPrintPortalManager_shipping_orders_by_tracking_grid',
        component: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_orders_by_tracking_gridDialog(
    inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], reference?: string, materialIds?: number[], fromDate?: string, toDate?: string, ship_to_search?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
      'Shipping orders by tracking number',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_orders_grid(inParams:{ projectId?: number, warehouseId?: number[], statusIds?: number[], reference?: string, materialIds?: number[], fromDate?: string, toDate?: string, ownerId: number, ship_to_search?: string }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Shipping orders',
        referenceName: 'FootPrintPortalManager_shipping_orders_grid',
        component: FootPrintPortalManager_shipping_orders_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshipping_orders_gridDialog(
    inParams:{ projectId?: number, warehouseId?: number[], statusIds?: number[], reference?: string, materialIds?: number[], fromDate?: string, toDate?: string, ownerId: number, ship_to_search?: string }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_orders_gridComponent,
      'Shipping orders',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshippingcontents_grid(inParams:{ orderId: number, shipmentId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Shipping contents',
        referenceName: 'FootPrintPortalManager_shippingcontents_grid',
        component: FootPrintPortalManager_shippingcontents_gridComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openshippingcontents_gridDialog(
    inParams:{ orderId: number, shipmentId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shippingcontents_gridComponent,
      'Shipping contents',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_hub(inParams:{ ownerId?: number, projectId?: number, warehouseId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory Hub',
        referenceName: 'FootPrintPortalManager_inventory_hub',
        component: FootPrintPortalManager_inventory_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinventory_hubDialog(
    inParams:{ ownerId?: number, projectId?: number, warehouseId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_hubComponent,
      'Inventory Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openinventory_transactions_hub(replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Inventory Transactions Hub',
        referenceName: 'FootPrintPortalManager_inventory_transactions_hub',
        component: FootPrintPortalManager_inventory_transactions_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openinventory_transactions_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_inventory_transactions_hubComponent,
      'Inventory Transactions Hub',
      mode,
      dialogSize
    )
  }
  public openinvoices_hub(inParams:{ ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Invoices Hub',
        referenceName: 'FootPrintPortalManager_invoices_hub',
        component: FootPrintPortalManager_invoices_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openinvoices_hubDialog(
    inParams:{ ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_invoices_hubComponent,
      'Invoices Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openlots_hub(inParams:{ ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Lots Hub',
        referenceName: 'FootPrintPortalManager_lots_hub',
        component: FootPrintPortalManager_lots_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openlots_hubDialog(
    inParams:{ ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_lots_hubComponent,
      'Lots Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterial_attachments_hub(inParams:{ materialId: number, packagingId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Material attachments',
        referenceName: 'FootPrintPortalManager_material_attachments_hub',
        component: FootPrintPortalManager_material_attachments_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterial_attachments_hubDialog(
    inParams:{ materialId: number, packagingId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_material_attachments_hubComponent,
      'Material attachments',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openmaterials_hub(inParams:{ ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Materials Hub',
        referenceName: 'FootPrintPortalManager_materials_hub',
        component: FootPrintPortalManager_materials_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openmaterials_hubDialog(
    inParams:{ ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_materials_hubComponent,
      'Materials Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openorders_dashboard_hub(replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Orders Dashboard',
        referenceName: 'FootPrintPortalManager_orders_dashboard_hub',
        component: FootPrintPortalManager_orders_dashboard_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openorders_dashboard_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_orders_dashboard_hubComponent,
      'Orders Dashboard',
      mode,
      dialogSize
    )
  }
  public openorders_hub(replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Orders Hub',
        referenceName: 'FootPrintPortalManager_orders_hub',
        component: FootPrintPortalManager_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openorders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_orders_hubComponent,
      'Orders Hub',
      mode,
      dialogSize
    )
  }
  public openreceiving_orders_hub(replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Receiving Orders Hub',
        referenceName: 'FootPrintPortalManager_receiving_orders_hub',
        component: FootPrintPortalManager_receiving_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openreceiving_orders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_receiving_orders_hubComponent,
      'Receiving Orders Hub',
      mode,
      dialogSize
    )
  }
  public openserialnumbers_hub(inParams:{ ownerId?: number, projectId?: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Serialnumbers Hub',
        referenceName: 'FootPrintPortalManager_serialnumbers_hub',
        component: FootPrintPortalManager_serialnumbers_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public openserialnumbers_hubDialog(
    inParams:{ ownerId?: number, projectId?: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_serialnumbers_hubComponent,
      'Serialnumbers Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public openshipping_orders_hub(replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Shipping Orders Hub',
        referenceName: 'FootPrintPortalManager_shipping_orders_hub',
        component: FootPrintPortalManager_shipping_orders_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openshipping_orders_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_shipping_orders_hubComponent,
      'Shipping Orders Hub',
      mode,
      dialogSize
    )
  }
  public opensingle_lot_hub(inParams:{ lotId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Single Lot Hub',
        referenceName: 'FootPrintPortalManager_single_lot_hub',
        component: FootPrintPortalManager_single_lot_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_lot_hubDialog(
    inParams:{ lotId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_single_lot_hubComponent,
      'Single Lot Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_material_hub(inParams:{ materialId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Single Material Hub',
        referenceName: 'FootPrintPortalManager_single_material_hub',
        component: FootPrintPortalManager_single_material_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_material_hubDialog(
    inParams:{ materialId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_single_material_hubComponent,
      'Single Material Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_pallet_hub(inParams:{ licenseplateId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Single Pallet Hub',
        referenceName: 'FootPrintPortalManager_single_pallet_hub',
        component: FootPrintPortalManager_single_pallet_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_pallet_hubDialog(
    inParams:{ licenseplateId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_single_pallet_hubComponent,
      'Single Pallet Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_project_hub(inParams:{ projectId: number, ownerId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Single Project Hub',
        referenceName: 'FootPrintPortalManager_single_project_hub',
        component: FootPrintPortalManager_single_project_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_project_hubDialog(
    inParams:{ projectId: number, ownerId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_single_project_hubComponent,
      'Single Project Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }
  public opensingle_serialnumber_hub(inParams:{ serialnumberId: number }, replaceCurrentView?: boolean) {
    ShellService.openViewRequest$.next(
      {
        title: 'Single Serialnumber Hub',
        referenceName: 'FootPrintPortalManager_single_serialnumber_hub',
        component: FootPrintPortalManager_single_serialnumber_hubComponent,
        replaceCurrentView: replaceCurrentView,
        inParams: inParams
      }
    );
  }

  public opensingle_serialnumber_hubDialog(
    inParams:{ serialnumberId: number }, 
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      FootPrintPortalManager_single_serialnumber_hubComponent,
      'Single Serialnumber Hub',
      mode,
      dialogSize
      , cloneDeep(inParams)
    )
  }

  public getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'FootPrintPortalManager_dock_appointment_cancel_options_form') {
      const title = 'Dock Appointment Cancellation';
      const component = FootPrintPortalManager_dock_appointment_cancel_options_formComponent;
      const inParams:{ title?: string } = { title: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_dock_appointment_creation_form') {
      const title = 'Create Dock Appointment';
      const component = FootPrintPortalManager_dock_appointment_creation_formComponent;
      const inParams:{ warehouseId?: number[], lookupcode?: string, scheduledArrival?: string, scheduledDeparture?: string, dockDoor?: number, typeId?: number, ownerId?: number, projectId?: number, carrierId?: number, orderId?: number, loadContainerId?: number } = { warehouseId: [], lookupcode: null, scheduledArrival: null, scheduledDeparture: null, dockDoor: null, typeId: null, ownerId: null, projectId: null, carrierId: null, orderId: null, loadContainerId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('lookupcode'))) {
        const paramValueString = params.get('lookupcode');
        // TODO: date
        inParams.lookupcode = paramValueString;
              }
      if (!isNil(params.get('scheduledArrival'))) {
        const paramValueString = params.get('scheduledArrival');
        // TODO: date
        inParams.scheduledArrival = paramValueString;
              }
      if (!isNil(params.get('scheduledDeparture'))) {
        const paramValueString = params.get('scheduledDeparture');
        // TODO: date
        inParams.scheduledDeparture = paramValueString;
              }
      if (!isNil(params.get('dockDoor'))) {
        const paramValueString = params.get('dockDoor');
        inParams.dockDoor = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('typeId'))) {
        const paramValueString = params.get('typeId');
        inParams.typeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('carrierId'))) {
        const paramValueString = params.get('carrierId');
        inParams.carrierId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_lot_bulk_update_status_form') {
      const title = 'Lot status update';
      const component = FootPrintPortalManager_lot_bulk_update_status_formComponent;
      const inParams:{ message: string } = { message: null };
      if (!isNil(params.get('message'))) {
        const paramValueString = params.get('message');
        // TODO: date
        inParams.message = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_lot_creation_form') {
      const title = 'Create Lot';
      const component = FootPrintPortalManager_lot_creation_formComponent;
      const inParams:{ materialId: number, lotLookupCode?: string, vendorLotLookupCode?: string, vendorLotId?: number } = { materialId: null, lotLookupCode: null, vendorLotLookupCode: null, vendorLotId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotLookupCode'))) {
        const paramValueString = params.get('lotLookupCode');
        // TODO: date
        inParams.lotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_material_creation_form') {
      const title = 'Create Material';
      const component = FootPrintPortalManager_material_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number } = { projectId: null, ownerId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_order_creation_form') {
      const title = 'Create Receiving Order';
      const component = FootPrintPortalManager_receiving_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_orders_update_form') {
      const title = 'Update Receiving Orders';
      const component = FootPrintPortalManager_receiving_orders_update_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_order_cancellation_options_form') {
      const title = 'Generic Shipping Order Cancellation ';
      const component = FootPrintPortalManager_shipping_order_cancellation_options_formComponent;
      const inParams:{ title?: string, parentId: number, parentEntity: string } = { title: null, parentId: null, parentEntity: null };
      if (!isNil(params.get('title'))) {
        const paramValueString = params.get('title');
        // TODO: date
        inParams.title = paramValueString;
              }
      if (!isNil(params.get('parentId'))) {
        const paramValueString = params.get('parentId');
        inParams.parentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('parentEntity'))) {
        const paramValueString = params.get('parentEntity');
        // TODO: date
        inParams.parentEntity = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_order_creation_form') {
      const title = 'Create Shipping Order';
      const component = FootPrintPortalManager_shipping_order_creation_formComponent;
      const inParams:{ projectId?: number, ownerId?: number, warehouseId?: number } = { projectId: null, ownerId: null, warehouseId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_orders_update_form') {
      const title = 'Update Shipping Orders';
      const component = FootPrintPortalManager_shipping_orders_update_formComponent;
      const inParams:{ orders: { orderId?: number, shipmentId?: number }[] } = { orders: [] };
      if (!isNil(params.get('orders'))) {
        const paramValueString = params.get('orders');
        inParams.orders = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_vendorlot_creation_form') {
      const title = 'Create Vendor Lot';
      const component = FootPrintPortalManager_vendorlot_creation_formComponent;
      const inParams:{ materialId: number, vendorLookupcode?: string } = { materialId: null, vendorLookupcode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLookupcode'))) {
        const paramValueString = params.get('vendorLookupcode');
        // TODO: date
        inParams.vendorLookupcode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_asn_order_editor') {
      const title = 'Edit ASN Order';
      const component = FootPrintPortalManager_asn_order_editorComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_dock_appointment_editor') {
      const title = 'Dock Appointment Editor';
      const component = FootPrintPortalManager_dock_appointment_editorComponent;
      const inParams:{ dockAppointmentId: number, orderId?: number, loadContainerId?: number } = { dockAppointmentId: null, orderId: null, loadContainerId: null };
      if (!isNil(params.get('dockAppointmentId'))) {
        const paramValueString = params.get('dockAppointmentId');
        inParams.dockAppointmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('loadContainerId'))) {
        const paramValueString = params.get('loadContainerId');
        inParams.loadContainerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_invoice_editor') {
      const title = 'View Invoice';
      const component = FootPrintPortalManager_invoice_editorComponent;
      const inParams:{ invoiceId: number } = { invoiceId: null };
      if (!isNil(params.get('invoiceId'))) {
        const paramValueString = params.get('invoiceId');
        inParams.invoiceId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_lot_editor') {
      const title = 'Edit Lot';
      const component = FootPrintPortalManager_lot_editorComponent;
      const inParams:{ lotId: number } = { lotId: null };
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_material_editor') {
      const title = 'Edit Material';
      const component = FootPrintPortalManager_material_editorComponent;
      const inParams:{ materialId: number } = { materialId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_pallet_editor') {
      const title = 'Edit Pallet';
      const component = FootPrintPortalManager_pallet_editorComponent;
      const inParams:{ licenseplateId: number } = { licenseplateId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_order_editor') {
      const title = 'Edit Receiving Order';
      const component = FootPrintPortalManager_receiving_order_editorComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_serialnumber_editor') {
      const title = 'Edit Serialnumber';
      const component = FootPrintPortalManager_serialnumber_editorComponent;
      const inParams:{ serialnumberId: number } = { serialnumberId: null };
      if (!isNil(params.get('serialnumberId'))) {
        const paramValueString = params.get('serialnumberId');
        inParams.serialnumberId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_order_editor') {
      const title = 'Edit Shipping Order';
      const component = FootPrintPortalManager_shipping_order_editorComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_accounts_grid') {
      const title = 'Addresses';
      const component = FootPrintPortalManager_accounts_gridComponent;
      const inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean } = { ownerId: null, accountTypeId: null, typeIds: [], allowSelection: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('accountTypeId'))) {
        const paramValueString = params.get('accountTypeId');
        inParams.accountTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('allowSelection'))) {
        const paramValueString = params.get('allowSelection');
        inParams.allowSelection = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_asn_order_licenseplates_grid') {
      const title = 'Pallets';
      const component = FootPrintPortalManager_asn_order_licenseplates_gridComponent;
      const inParams:{ orderId: number, orderStatusId: number, projectId: number } = { orderId: null, orderStatusId: null, projectId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_asn_order_licenseplates_receiving_tasks_grid') {
      const title = 'Receiving tasks';
      const component = FootPrintPortalManager_asn_order_licenseplates_receiving_tasks_gridComponent;
      const inParams:{ licenseplateId: number, orderId: number, projectId: number, orderStatusId: number } = { licenseplateId: null, orderId: null, projectId: null, orderStatusId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_asn_order_receiving_tasks_grid') {
      const title = 'Receiving tasks';
      const component = FootPrintPortalManager_asn_order_receiving_tasks_gridComponent;
      const inParams:{ orderId: number, orderStatusId: number } = { orderId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_asn_order_tasks_grid') {
      const title = 'Asn order tasks';
      const component = FootPrintPortalManager_asn_order_tasks_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_billing_records_by_invoiceline_grid') {
      const title = 'Billing records by invoice line';
      const component = FootPrintPortalManager_billing_records_by_invoiceline_gridComponent;
      const inParams:{ invoiceLineId: number } = { invoiceLineId: null };
      if (!isNil(params.get('invoiceLineId'))) {
        const paramValueString = params.get('invoiceLineId');
        inParams.invoiceLineId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_entity_attachments_grid') {
      const title = 'Attachments';
      const component = FootPrintPortalManager_entity_attachments_gridComponent;
      const inParams:{ entityType: string, entityKeys: { name?: string, value?: any }[] } = { entityType: null, entityKeys: [] };
      if (!isNil(params.get('entityType'))) {
        const paramValueString = params.get('entityType');
        // TODO: date
        inParams.entityType = paramValueString;
              }
      if (!isNil(params.get('entityKeys'))) {
        const paramValueString = params.get('entityKeys');
        inParams.entityKeys = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_instructions_grid') {
      const title = 'Instructions';
      const component = FootPrintPortalManager_instructions_gridComponent;
      const inParams:{ entityName: string, enabled: boolean, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number } = { entityName: null, enabled: null, typeIds: [], entityKey1: null, entityKey2: null, entityKey3: null, entityKey4: null };
      if (!isNil(params.get('entityName'))) {
        const paramValueString = params.get('entityName');
        // TODO: date
        inParams.entityName = paramValueString;
              }
      if (!isNil(params.get('enabled'))) {
        const paramValueString = params.get('enabled');
        inParams.enabled = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('entityKey1'))) {
        const paramValueString = params.get('entityKey1');
        inParams.entityKey1 = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('entityKey2'))) {
        const paramValueString = params.get('entityKey2');
        inParams.entityKey2 = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('entityKey3'))) {
        const paramValueString = params.get('entityKey3');
        inParams.entityKey3 = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('entityKey4'))) {
        const paramValueString = params.get('entityKey4');
        inParams.entityKey4 = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_lot_grid') {
      const title = 'Inventory by lot';
      const component = FootPrintPortalManager_inventory_lot_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], lotId?: number } = { ownerId: null, projectId: null, warehouseId: null, materialIds: [], lotId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_lot_snapshot_grid') {
      const title = 'Inventory lot snapshot';
      const component = FootPrintPortalManager_inventory_lot_snapshot_gridComponent;
      const inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] } = { captureDate: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('captureDate'))) {
        const paramValueString = params.get('captureDate');
        // TODO: date
        inParams.captureDate = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_material_grid') {
      const title = 'Inventory by material';
      const component = FootPrintPortalManager_inventory_material_gridComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] } = { ownerId: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_material_snapshot_grid') {
      const title = 'Inventory material snapshot';
      const component = FootPrintPortalManager_inventory_material_snapshot_gridComponent;
      const inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] } = { captureDate: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('captureDate'))) {
        const paramValueString = params.get('captureDate');
        // TODO: date
        inParams.captureDate = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_pallet_grid') {
      const title = 'Inventory by pallet';
      const component = FootPrintPortalManager_inventory_pallet_gridComponent;
      const inParams:{ licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[] } = { licenseplateId: null, ownerId: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_pallet_snapshot_grid') {
      const title = 'Inventory pallet snapshot';
      const component = FootPrintPortalManager_inventory_pallet_snapshot_gridComponent;
      const inParams:{ captureDate: string, projectId: number, warehouseId: number, materialIds?: number[] } = { captureDate: null, projectId: null, warehouseId: null, materialIds: [] };
      if (!isNil(params.get('captureDate'))) {
        const paramValueString = params.get('captureDate');
        // TODO: date
        inParams.captureDate = paramValueString;
              }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_tasks_grid') {
      const title = 'Inventory tasks';
      const component = FootPrintPortalManager_inventory_tasks_gridComponent;
      const inParams:{ materialIds?: number[], projectId?: number, ownerId?: number, warehouseIds?: number[], serialnumberId?: number, licenseplateId?: number, lotId?: number } = { materialIds: [], projectId: null, ownerId: null, warehouseIds: [], serialnumberId: null, licenseplateId: null, lotId: null };
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('serialnumberId'))) {
        const paramValueString = params.get('serialnumberId');
        inParams.serialnumberId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_transactions_grid') {
      const title = 'Transactions';
      const component = FootPrintPortalManager_inventory_transactions_gridComponent;
      const inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], createdFrom?: string, createdTo?: string, materialIds?: number[], operationCodeIds?: number[] } = { ownerId: null, projectId: null, warehouseId: [], createdFrom: null, createdTo: null, materialIds: [], operationCodeIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('createdFrom'))) {
        const paramValueString = params.get('createdFrom');
        // TODO: date
        inParams.createdFrom = paramValueString;
              }
      if (!isNil(params.get('createdTo'))) {
        const paramValueString = params.get('createdTo');
        // TODO: date
        inParams.createdTo = paramValueString;
              }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('operationCodeIds'))) {
        const paramValueString = params.get('operationCodeIds');
        inParams.operationCodeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_invoice_lines_grid') {
      const title = 'Invoice lines';
      const component = FootPrintPortalManager_invoice_lines_gridComponent;
      const inParams:{ invoiceId: number } = { invoiceId: null };
      if (!isNil(params.get('invoiceId'))) {
        const paramValueString = params.get('invoiceId');
        inParams.invoiceId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_invoices_grid') {
      const title = 'Invoices';
      const component = FootPrintPortalManager_invoices_gridComponent;
      const inParams:{ ownerId: number, projectId?: number, statusIds: number[] } = { ownerId: null, projectId: null, statusIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_lots_grid_flat') {
      const title = 'Lots grid from flat data source';
      const component = FootPrintPortalManager_lots_grid_flatComponent;
      const inParams:{ ownerId: number, projectId?: number, materialIds?: number[], statusIds?: number[] } = { ownerId: null, projectId: null, materialIds: [], statusIds: [] };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_material_packagings_grid') {
      const title = 'Packagings';
      const component = FootPrintPortalManager_material_packagings_gridComponent;
      const inParams:{ materialId?: number } = { materialId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_materials_by_base_packaging_grid') {
      const title = 'Materials';
      const component = FootPrintPortalManager_materials_by_base_packaging_gridComponent;
      const inParams:{ projectId?: number, ownerId: number, materialIds?: number[] } = { projectId: null, ownerId: null, materialIds: [] };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_orderaddresses_grid') {
      const title = 'Order addresses';
      const component = FootPrintPortalManager_orderaddresses_gridComponent;
      const inParams:{ orderId: number } = { orderId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_orders_dashboard_grid') {
      const title = 'Order dashboard';
      const component = FootPrintPortalManager_orders_dashboard_gridComponent;
      const inParams:{ ownerId: number, projectId?: number, warehouseIds: number[], typeIds?: number[], statusIds?: number[], fromDate?: string, toDate?: string } = { ownerId: null, projectId: null, warehouseIds: [], typeIds: [], statusIds: [], fromDate: null, toDate: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('fromDate'))) {
        const paramValueString = params.get('fromDate');
        // TODO: date
        inParams.fromDate = paramValueString;
              }
      if (!isNil(params.get('toDate'))) {
        const paramValueString = params.get('toDate');
        // TODO: date
        inParams.toDate = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_ownersaccounts_grid') {
      const title = 'Contacts';
      const component = FootPrintPortalManager_ownersaccounts_gridComponent;
      const inParams:{ ownerId: number, accountTypeId: number, typeIds: number[], allowSelection: boolean } = { ownerId: null, accountTypeId: null, typeIds: [], allowSelection: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('accountTypeId'))) {
        const paramValueString = params.get('accountTypeId');
        inParams.accountTypeId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('typeIds'))) {
        const paramValueString = params.get('typeIds');
        inParams.typeIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('allowSelection'))) {
        const paramValueString = params.get('allowSelection');
        inParams.allowSelection = this.convertToBoolean(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_order_lines_grid') {
      const title = 'Receiving order lines';
      const component = FootPrintPortalManager_receiving_order_lines_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number } = { orderId: null, shipmentId: null, projectId: null, orderStatusId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_order_received_inventory_grid') {
      const title = 'Received Inventory';
      const component = FootPrintPortalManager_receiving_order_received_inventory_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_order_tasks_grid') {
      const title = 'Receiving order tasks';
      const component = FootPrintPortalManager_receiving_order_tasks_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_orders_grid') {
      const title = 'Receiving orders';
      const component = FootPrintPortalManager_receiving_orders_gridComponent;
      const inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], materialIds?: number[], reference?: string, fromDate?: string, toDate?: string } = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], materialIds: [], reference: null, fromDate: null, toDate: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('reference'))) {
        const paramValueString = params.get('reference');
        // TODO: date
        inParams.reference = paramValueString;
              }
      if (!isNil(params.get('fromDate'))) {
        const paramValueString = params.get('fromDate');
        // TODO: date
        inParams.fromDate = paramValueString;
              }
      if (!isNil(params.get('toDate'))) {
        const paramValueString = params.get('toDate');
        // TODO: date
        inParams.toDate = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_serialnumbers_grid') {
      const title = 'Serial numbers';
      const component = FootPrintPortalManager_serialnumbers_gridComponent;
      const inParams:{ licenseplateIds?: number[], warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId: number, archived?: boolean, search?: string } = { licenseplateIds: [], warehouseIds: [], lotId: null, materialIds: [], projectId: null, ownerId: null, archived: null, search: null };
      if (!isNil(params.get('licenseplateIds'))) {
        const paramValueString = params.get('licenseplateIds');
        inParams.licenseplateIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('warehouseIds'))) {
        const paramValueString = params.get('warehouseIds');
        inParams.warehouseIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('archived'))) {
        const paramValueString = params.get('archived');
        inParams.archived = this.convertToBoolean(paramValueString);
      }
      if (!isNil(params.get('search'))) {
        const paramValueString = params.get('search');
        // TODO: date
        inParams.search = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_order_lines_grid') {
      const title = 'Shipping order lines';
      const component = FootPrintPortalManager_shipping_order_lines_gridComponent;
      const inParams:{ orderId: number, shipmentId: number, projectId: number, orderStatusId: number, warehouseId: number, orderState?: number } = { orderId: null, shipmentId: null, projectId: null, orderStatusId: null, warehouseId: null, orderState: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderStatusId'))) {
        const paramValueString = params.get('orderStatusId');
        inParams.orderStatusId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('orderState'))) {
        const paramValueString = params.get('orderState');
        inParams.orderState = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_order_tasks_grid') {
      const title = 'Shipping order tasks';
      const component = FootPrintPortalManager_shipping_order_tasks_gridComponent;
      const inParams:{ orderId?: number, shipmentId?: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_orders_by_tracking_grid') {
      const title = 'Shipping orders by tracking number';
      const component = FootPrintPortalManager_shipping_orders_by_tracking_gridComponent;
      const inParams:{ ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], reference?: string, materialIds?: number[], fromDate?: string, toDate?: string, ship_to_search?: string } = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], reference: null, materialIds: [], fromDate: null, toDate: null, ship_to_search: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('reference'))) {
        const paramValueString = params.get('reference');
        // TODO: date
        inParams.reference = paramValueString;
              }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('fromDate'))) {
        const paramValueString = params.get('fromDate');
        // TODO: date
        inParams.fromDate = paramValueString;
              }
      if (!isNil(params.get('toDate'))) {
        const paramValueString = params.get('toDate');
        // TODO: date
        inParams.toDate = paramValueString;
              }
      if (!isNil(params.get('ship_to_search'))) {
        const paramValueString = params.get('ship_to_search');
        // TODO: date
        inParams.ship_to_search = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_orders_grid') {
      const title = 'Shipping orders';
      const component = FootPrintPortalManager_shipping_orders_gridComponent;
      const inParams:{ projectId?: number, warehouseId?: number[], statusIds?: number[], reference?: string, materialIds?: number[], fromDate?: string, toDate?: string, ownerId: number, ship_to_search?: string } = { projectId: null, warehouseId: [], statusIds: [], reference: null, materialIds: [], fromDate: null, toDate: null, ownerId: null, ship_to_search: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('statusIds'))) {
        const paramValueString = params.get('statusIds');
        inParams.statusIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('reference'))) {
        const paramValueString = params.get('reference');
        // TODO: date
        inParams.reference = paramValueString;
              }
      if (!isNil(params.get('materialIds'))) {
        const paramValueString = params.get('materialIds');
        inParams.materialIds = this.convertToJSON(paramValueString);
      }
      if (!isNil(params.get('fromDate'))) {
        const paramValueString = params.get('fromDate');
        // TODO: date
        inParams.fromDate = paramValueString;
              }
      if (!isNil(params.get('toDate'))) {
        const paramValueString = params.get('toDate');
        // TODO: date
        inParams.toDate = paramValueString;
              }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ship_to_search'))) {
        const paramValueString = params.get('ship_to_search');
        // TODO: date
        inParams.ship_to_search = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shippingcontents_grid') {
      const title = 'Shipping contents';
      const component = FootPrintPortalManager_shippingcontents_gridComponent;
      const inParams:{ orderId: number, shipmentId: number } = { orderId: null, shipmentId: null };
      if (!isNil(params.get('orderId'))) {
        const paramValueString = params.get('orderId');
        inParams.orderId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('shipmentId'))) {
        const paramValueString = params.get('shipmentId');
        inParams.shipmentId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_hub') {
      const title = 'Inventory Hub';
      const component = FootPrintPortalManager_inventory_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number, warehouseId?: number } = { ownerId: null, projectId: null, warehouseId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_transactions_hub') {
      const title = 'Inventory Transactions Hub';
      const component = FootPrintPortalManager_inventory_transactions_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_invoices_hub') {
      const title = 'Invoices Hub';
      const component = FootPrintPortalManager_invoices_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number } = { ownerId: null, projectId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_lots_hub') {
      const title = 'Lots Hub';
      const component = FootPrintPortalManager_lots_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number } = { ownerId: null, projectId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_material_attachments_hub') {
      const title = 'Material attachments';
      const component = FootPrintPortalManager_material_attachments_hubComponent;
      const inParams:{ materialId: number, packagingId?: number } = { materialId: null, packagingId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('packagingId'))) {
        const paramValueString = params.get('packagingId');
        inParams.packagingId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_materials_hub') {
      const title = 'Materials Hub';
      const component = FootPrintPortalManager_materials_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number } = { ownerId: null, projectId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_orders_dashboard_hub') {
      const title = 'Orders Dashboard';
      const component = FootPrintPortalManager_orders_dashboard_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_orders_hub') {
      const title = 'Orders Hub';
      const component = FootPrintPortalManager_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_receiving_orders_hub') {
      const title = 'Receiving Orders Hub';
      const component = FootPrintPortalManager_receiving_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_serialnumbers_hub') {
      const title = 'Serialnumbers Hub';
      const component = FootPrintPortalManager_serialnumbers_hubComponent;
      const inParams:{ ownerId?: number, projectId?: number } = { ownerId: null, projectId: null };
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_shipping_orders_hub') {
      const title = 'Shipping Orders Hub';
      const component = FootPrintPortalManager_shipping_orders_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_single_lot_hub') {
      const title = 'Single Lot Hub';
      const component = FootPrintPortalManager_single_lot_hubComponent;
      const inParams:{ lotId: number } = { lotId: null };
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_single_material_hub') {
      const title = 'Single Material Hub';
      const component = FootPrintPortalManager_single_material_hubComponent;
      const inParams:{ materialId: number } = { materialId: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_single_pallet_hub') {
      const title = 'Single Pallet Hub';
      const component = FootPrintPortalManager_single_pallet_hubComponent;
      const inParams:{ licenseplateId: number } = { licenseplateId: null };
      if (!isNil(params.get('licenseplateId'))) {
        const paramValueString = params.get('licenseplateId');
        inParams.licenseplateId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_single_project_hub') {
      const title = 'Single Project Hub';
      const component = FootPrintPortalManager_single_project_hubComponent;
      const inParams:{ projectId: number, ownerId: number } = { projectId: null, ownerId: null };
      if (!isNil(params.get('projectId'))) {
        const paramValueString = params.get('projectId');
        inParams.projectId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('ownerId'))) {
        const paramValueString = params.get('ownerId');
        inParams.ownerId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_single_serialnumber_hub') {
      const title = 'Single Serialnumber Hub';
      const component = FootPrintPortalManager_single_serialnumber_hubComponent;
      const inParams:{ serialnumberId: number } = { serialnumberId: null };
      if (!isNil(params.get('serialnumberId'))) {
        const paramValueString = params.get('serialnumberId');
        inParams.serialnumberId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_archived_options_dd_single') {
      const title = 'archived_options_dd';
      const component = FootPrintPortalManager_archived_options_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inbound_outbound_appointment_types_dd_single') {
      const title = 'inbound_outbound_appointment_types_dd';
      const component = FootPrintPortalManager_inbound_outbound_appointment_types_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_aggregation_dd_single') {
      const title = 'Inventory aggregation type';
      const component = FootPrintPortalManager_inventory_aggregation_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_lots_dd_single') {
      const title = 'Lots dropdown';
      const component = FootPrintPortalManager_lots_dd_singleComponent;
      const inParams:{ materialId: number, vendorLotId?: number, lotLookupCode?: string, vendorLotLookupCode?: string } = { materialId: null, vendorLotId: null, lotLookupCode: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotLookupCode'))) {
        const paramValueString = params.get('lotLookupCode');
        // TODO: date
        inParams.lotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_operationcodes_dd_single') {
      const title = 'Operation Codes';
      const component = FootPrintPortalManager_operationcodes_dd_singleComponent;
      const inParams:{ operationCodeIds: number[] } = { operationCodeIds: [] };
      if (!isNil(params.get('operationCodeIds'))) {
        const paramValueString = params.get('operationCodeIds');
        inParams.operationCodeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_vendorlots_dd_single') {
      const title = 'Vendor Lots dropdown';
      const component = FootPrintPortalManager_vendorlots_dd_singleComponent;
      const inParams:{ materialId: number, lotId?: number, vendorLotLookupCode?: string } = { materialId: null, lotId: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_archived_options_dd_multi') {
      const title = 'archived_options_dd';
      const component = FootPrintPortalManager_archived_options_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inbound_outbound_appointment_types_dd_multi') {
      const title = 'inbound_outbound_appointment_types_dd';
      const component = FootPrintPortalManager_inbound_outbound_appointment_types_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_inventory_aggregation_dd_multi') {
      const title = 'Inventory aggregation type';
      const component = FootPrintPortalManager_inventory_aggregation_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_lots_dd_multi') {
      const title = 'Lots dropdown';
      const component = FootPrintPortalManager_lots_dd_multiComponent;
      const inParams:{ materialId: number, vendorLotId?: number, lotLookupCode?: string, vendorLotLookupCode?: string } = { materialId: null, vendorLotId: null, lotLookupCode: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotId'))) {
        const paramValueString = params.get('vendorLotId');
        inParams.vendorLotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotLookupCode'))) {
        const paramValueString = params.get('lotLookupCode');
        // TODO: date
        inParams.lotLookupCode = paramValueString;
              }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_operationcodes_dd_multi') {
      const title = 'Operation Codes';
      const component = FootPrintPortalManager_operationcodes_dd_multiComponent;
      const inParams:{ operationCodeIds: number[] } = { operationCodeIds: [] };
      if (!isNil(params.get('operationCodeIds'))) {
        const paramValueString = params.get('operationCodeIds');
        inParams.operationCodeIds = this.convertToJSON(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'FootPrintPortalManager_vendorlots_dd_multi') {
      const title = 'Vendor Lots dropdown';
      const component = FootPrintPortalManager_vendorlots_dd_multiComponent;
      const inParams:{ materialId: number, lotId?: number, vendorLotLookupCode?: string } = { materialId: null, lotId: null, vendorLotLookupCode: null };
      if (!isNil(params.get('materialId'))) {
        const paramValueString = params.get('materialId');
        inParams.materialId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('lotId'))) {
        const paramValueString = params.get('lotId');
        inParams.lotId = this.convertToNumber(paramValueString);
      }
      if (!isNil(params.get('vendorLotLookupCode'))) {
        const paramValueString = params.get('vendorLotLookupCode');
        // TODO: date
        inParams.vendorLotLookupCode = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }

    let result = null;
    result = this.Discussions.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Addresses.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.AsnOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Attachments.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Carriers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Instructions.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ExcelOrderImport.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Locations.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Lots.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.LoadContainers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Owners.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.PurchaseOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Invoices.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Notifications.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Materials.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.DockAppointments.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.SerialNumbers.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.SalesOrders.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Inventory.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
